export default __webpack_public_path__ + "static/dividersstraight-cb609769e7f4077e4657b66fba2993af.png";